import { render, staticRenderFns } from "./OrderDetailVideoCell.vue?vue&type=template&id=755938d2&"
import script from "./OrderDetailVideoCell.vue?vue&type=script&lang=js&"
export * from "./OrderDetailVideoCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports